var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstimateAiAge(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4252 7.425C9.97519 8.1 8.92519 9.15 8.25019 12.6C7.5752 9.15 6.52519 8.1 3.0752 7.425C6.52519 6.75 7.5752 5.7 8.25019 2.25C8.92519 5.7 9.97519 6.75 13.4252 7.425Z",
    stroke: "#20C3FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3504 18.75C13.9504 19.2 13.2754 19.95 12.7504 22.35C12.3004 19.95 11.5504 19.275 9.15039 18.75C11.5504 18.3 12.2254 17.55 12.7504 15.15C13.2004 17.55 13.9504 18.3 16.3504 18.75Z",
    stroke: "#20C3FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7504 11.25C19.8004 11.625 19.2004 12.225 18.8254 14.175C18.4504 12.225 17.8504 11.625 15.9004 11.25C17.8504 10.875 18.4504 10.275 18.8254 8.32501C19.2004 10.275 19.8004 10.875 21.7504 11.25Z",
    stroke: "#20C3FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimateAiAge);
export default __webpack_public_path__ + "static/media/estimate-ai-age.c9d3b3eec1f19dcf354c1dc06a47ae75.svg";
export { ForwardRef as ReactComponent };